import React, { useState } from 'react';
import './ResetPassword.css';
import walkinImg from '../../../images/logoWithText.jpeg';
import { Col, Row, Button, Form, FormGroup, Label, Input } from 'reactstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import { checkPasswordToken, resetPassword } from '../../../constants/apiCalls';
import ModalService from '../../../services/ModalService';
import { handleErrorMessage } from '../../../utils/utils';
import { messages } from '../../../utils/constant-messages';
import CustomSpinner from '../../../Components/CustomSpinner/CustomSpinner';

const ResetPassword = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const urlSearchParams = new URLSearchParams(location.search);
    const token = urlSearchParams.get('token');
    const initState = { pswd: '', confirmPswd: '' }
    const [isLoading, setIsloading] = useState(false);
    const [data, setData] = useState(initState);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setData({ ...data, [name]: value });
    }

    const handlePassword = (evt) => {
        evt.preventDefault();
        let { pswd, confirmPswd } = data;
        if (pswd !== confirmPswd) {
            ModalService.openAlert('', messages.COMMON.NEW_CONFIRM_PASSWORD_MATCH_ERROR, 'error');
            return;
        }

        let tokenPayload = {
            token: token || '',
        };
        setIsloading(true);
        checkPasswordToken((res) => {
            const { success, error } = res;
            if (success === true) {

                let payload = {
                    token: token || '',
                    new_password: pswd,
                };
                resetPassword((res) => {
                    const { success, message, error } = res;
                    if (success === true) {
                        ModalService.openAlert('', message, 'success');
                        navigate('/user/login');
                        setIsloading(false);
                    }
                    else if (success === false || success === 'undefined') {
                        ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
                        setIsloading(false);
                    }
                    setIsloading(false);
                }, payload);
                setIsloading(false);
            }
            else if (success === false || success === 'undefined') {
                ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
                setIsloading(false);
            }
            setIsloading(false);
        }, tokenPayload);
    };
    return (
        <div id='resetPassword'>
            {isLoading && <CustomSpinner />}
            <Row className='no-gutters h-100 main-row'>
                <Col lg='4' className=' bg-white powered-by'></Col>
                <Col
                    lg='8'
                    md='12'
                    className=' d-flex bg-white justify-content-center align-items-center'
                >
                    {/* <hr className='vertical-line  bg-white' /> */}
                    <Col lg='8' md='8' sm='12' className='mx-auto app-login-box'>
                        <div className='logo'>
                            <img src={walkinImg} className='logo-img img-fluid' alt='' />
                        </div>
                        <div className='mt-4' />
                        <Form onSubmit={handlePassword}>
                            <hr />
                            <Row>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label for='examplePassword'>New Password <span className='required'>*</span></Label>
                                        <Input
                                            type='password'
                                            onChange={handleChange}
                                            name='pswd'
                                            value={data.pswd || ''}
                                            id='pswd'
                                            placeholder='New Password here...'
                                            required
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <FormGroup className='mb-0'>
                                        <Label for='exampleConfirmPassword'>Confirm Password <span className='required'>*</span></Label>
                                        <Input
                                            type='password'
                                            onChange={handleChange}
                                            name='confirmPswd'
                                            value={data.confirmPswd || ''}
                                            id='confirmPswd'
                                            placeholder='Confirm Password here...'
                                            required
                                            style={{ marginBottom: '8px' }}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <hr />
                            <Row>
                                <Col md={12}>
                                    <div className='mt-1 d-flex align-items-center'>
                                        <div>
                                            <Button
                                                className='set-password-btn'
                                                style={{
                                                    borderRadius: '18px',
                                                    fontWeight: '600',
                                                    textAlign: 'center',
                                                }}
                                                size='lg'
                                            >
                                                Set Password
                                            </Button>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Form>
                    </Col>
                </Col>
            </Row>
        </div>
    )
}

export default ResetPassword
